import React, { useState } from 'react'
import { Form,Button } from 'react-bootstrap'

const HotelArea = (props) => {
    const [hotelArea,setHotelArea] = useState('');
    const [showHotelAreaForm, setShowHotelAreaForm] = useState(true);

    const handleHotelAreaSubmit = (e) => {
       e.preventDefault();
       
       ;
       if (!hotelArea) {
         return 
         ; // If any field is empty, prevent form submission
       }
     
      props.actionProvider.handleHotelAreaSubmit(hotelArea);
      // setShowHotelAreaForm(false)
     };
   
     return (
       <div>
           {showHotelAreaForm && (
               <Form style={{backgroundColor: '#DFE1E1'}} className='p-3'>
               <Form.Control 
                      type="text" className='mb-2'
                      placeholder="Provide Area"
                      name="area"
                      value={hotelArea}
                      onChange={(e) => setHotelArea(e.target.value)}
                    />
                    <Button style={{backgroundColor:'#008080'}} onClick={handleHotelAreaSubmit}>Submit</Button>
              </Form>
           )}
       </div>
       
     )
}

export default HotelArea
